module.exports = __webpack_public_path__ + "static/img/tristan.767b065.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-page/tristan.jpg
// module id = 428
// module chunks = 1